/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreErrorKey } from '../key/core-error.key';
import { ApplicationError } from '../model/application-error.model';
import { Formatter, FormatterProvider } from '../provider/formatter.provider';

export function formatValue(value: any, formatterKey: string, options?: any): string {
  const formatter: Formatter = FormatterProvider.resolveFormatter(formatterKey, options);
  if (!formatter) {
    throw new ApplicationError({
      key: CoreErrorKey.FORMATTER_NOT_FOUND,
      arguments: { formatterKey },
      message: `Formatter '${formatterKey}' not found`
    });
  }
  return formatter.format(value);
}
